import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=38af7ae0&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=38af7ae0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af7ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38af7ae0')) {
      api.createRecord('38af7ae0', component.options)
    } else {
      api.reload('38af7ae0', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=38af7ae0&scoped=true", function () {
      api.rerender('38af7ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/Sidebar.vue"
export default component.exports